module.exports = __webpack_public_path__ + "img/xindai_step2_gzh.2093ff84.png";